import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlankPageRoutingModule } from './blank-page-routing.module';
import { BlankPageComponent } from './blank-page.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule} from '@angular/material';
import { SelectInstitutionsComponent } from './select-institutions/select-institutions.component';

@NgModule({
    imports: [CommonModule,
        TranslateModule,
        FormsModule,
        BlankPageRoutingModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule],
    declarations: [BlankPageComponent, SelectInstitutionsComponent],
    exports: [SelectInstitutionsComponent]
})
export class BlankPageModule {}
